var _defs, _g, _path, _path2, _g2, _g3, _path3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommbankCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 262.499992",
    height: 350,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.355469 20.351562 L 374.640625 20.351562 L 374.640625 241.792969 L 0.355469 241.792969 Z M 0.355469 20.351562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 39.65625 37.003906 L 87.46875 37.003906 L 87.46875 84.8125 L 39.65625 84.8125 Z M 39.65625 37.003906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.5625 37.003906 L 87.46875 60.910156 L 63.5625 84.8125 L 39.65625 60.910156 L 63.5625 37.003906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -2.53551,
    gradientTransform: "matrix(0.747049, 0, 0, -0.747049, 39.65578, -47.996197)",
    y1: -116.802324,
    x2: 66.540416,
    gradientUnits: "userSpaceOnUse",
    y2: -174.751796,
    id: "id4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 100%, 0%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 100%, 0%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 100%, 0%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 100%, 0%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.990845%, 99.880981%, 0.0991821%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.971008%, 99.617004%, 0.325012%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.949646%, 99.324036%, 0.575256%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.928284%, 99.032593%, 0.8255%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.906921%, 98.739624%, 1.075745%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.885559%, 98.446655%, 1.325989%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.865723%, 98.153687%, 1.576233%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.84436%, 97.860718%, 1.826477%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.822998%, 97.569275%, 2.076721%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.801636%, 97.276306%, 2.326965%)",
    offset: 0.304687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.780273%, 96.983337%, 2.575684%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.758911%, 96.690369%, 2.825928%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.737549%, 96.3974%, 3.076172%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.716187%, 96.104431%, 3.326416%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.694824%, 95.812988%, 3.57666%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.673462%, 95.52002%, 3.826904%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.6521%, 95.227051%, 4.077148%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.630737%, 94.934082%, 4.327393%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.609375%, 94.641113%, 4.577637%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.581909%, 94.306946%, 4.858398%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.549866%, 93.93158%, 5.169678%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.517822%, 93.556213%, 5.480957%)",
    offset: 0.398437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.485779%, 93.180847%, 5.792236%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.453735%, 92.805481%, 6.103516%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.423218%, 92.431641%, 6.414795%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.391174%, 92.056274%, 6.726074%)",
    offset: 0.429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.359131%, 91.680908%, 7.037354%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.327087%, 91.305542%, 7.348633%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.295044%, 90.930176%, 7.659912%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.263%, 90.55481%, 7.971191%)",
    offset: 0.456204
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.247742%, 90.367126%, 8.126831%)",
    offset: 0.460937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.230957%, 90.179443%, 8.282471%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.206543%, 89.805603%, 8.456421%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.198914%, 89.498901%, 8.392334%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.198914%, 89.256287%, 8.226013%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.198914%, 89.013672%, 8.059692%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.198914%, 88.772583%, 7.893372%)",
    offset: 0.543796
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.198914%, 88.652039%, 7.810974%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.198914%, 88.529968%, 7.727051%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.203491%, 88.25531%, 7.525635%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.223328%, 87.913513%, 7.232666%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.255371%, 87.538147%, 6.880188%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.287415%, 87.162781%, 6.529236%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.317932%, 86.78894%, 6.178284%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.349976%, 86.413574%, 5.827332%)",
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.382019%, 86.038208%, 5.476379%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.414062%, 85.662842%, 5.125427%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.446106%, 85.287476%, 4.772949%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.478149%, 84.912109%, 4.421997%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.510193%, 84.536743%, 4.071045%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.542236%, 84.162903%, 3.720093%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.57428%, 83.787537%, 3.369141%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.615479%, 83.364868%, 2.983093%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.641418%, 83.131409%, 2.772522%)",
    offset: 0.679687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.67041%, 82.879639%, 2.549744%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.699402%, 82.627869%, 2.326965%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.726868%, 82.376099%, 2.104187%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.755859%, 82.125854%, 1.881409%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.784851%, 81.874084%, 1.65863%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.813843%, 81.622314%, 1.437378%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.842834%, 81.370544%, 1.2146%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.871826%, 81.118774%, 0.991821%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.899292%, 80.867004%, 0.769043%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.928284%, 80.61676%, 0.546265%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.957275%, 80.36499%, 0.323486%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.986267%, 80.11322%, 0.100708%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.992371%, 80.055237%, 0.050354%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.998779%, 0%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.998779%, 0%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63 54 L 87.46875 54 L 87.46875 84.8125 L 63 84.8125 Z M 63 54 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 72.636719 63.328125 L 63.5625 84.8125 L 87.46875 60.910156 L 81.257812 54.691406 Z M 72.636719 63.328125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 26.269741,
    gradientTransform: "matrix(0.747049, 0, 0, -0.747049, 39.65578, -47.996197)",
    y1: -146.620546,
    x2: 67.398037,
    gradientUnits: "userSpaceOnUse",
    y2: -172.347773,
    id: "id7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.89917%, 26.699829%, 0%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.89917%, 26.699829%, 0%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.89917%, 26.699829%, 0%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.89917%, 26.699829%, 0%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.89917%, 26.699829%, 0%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.543518%, 28.977966%, 0%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.189392%, 31.257629%, 0%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.925293%, 33.615112%, 0%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.661194%, 35.972595%, 0%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.397095%, 38.330078%, 0%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.132996%, 40.687561%, 0%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.868896%, 43.045044%, 0%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.606323%, 45.402527%, 0%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.342224%, 47.76001%, 0%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.078125%, 50.117493%, 0%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.502747%, 52.253723%, 0%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.928894%, 54.391479%, 0%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.667419%, 55.329895%, 0%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.405945%, 56.268311%, 0%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.14447%, 57.206726%, 0%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.882996%, 58.145142%, 0%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.619995%, 59.083557%, 0%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.358521%, 60.023499%, 0%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.042114%, 60.943604%, 0%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.725708%, 61.863708%, 0%)",
    offset: 0.414063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.119385%, 62.689209%, 0%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.514587%, 63.516235%, 0%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.90979%, 64.341736%, 0%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.304993%, 65.168762%, 0%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.698669%, 65.994263%, 0%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.093872%, 66.819763%, 0%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.487549%, 67.645264%, 0%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.882751%, 68.47229%, 0%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.276428%, 69.297791%, 0%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.671631%, 70.124817%, 0%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.953918%, 71.005249%, 0.0427246%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.237732%, 71.885681%, 0.0869751%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.474243%, 72.787476%, 0.14801%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.710754%, 73.690796%, 0.209045%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.947266%, 74.59259%, 0.270081%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.185303%, 75.494385%, 0.331116%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.421814%, 76.396179%, 0.392151%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.659851%, 77.2995%, 0.453186%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.896362%, 78.201294%, 0.514221%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.134399%, 79.104614%, 0.575256%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.370911%, 80.006409%, 0.636292%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.607422%, 80.909729%, 0.698853%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.822571%, 81.715393%, 0.753784%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.03772%, 82.522583%, 0.808716%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.147583%, 82.873535%, 0.836182%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.257446%, 83.224487%, 0.863647%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.36731%, 83.575439%, 0.891113%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.478699%, 83.926392%, 0.918579%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.588562%, 84.277344%, 0.946045%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.698425%, 84.628296%, 0.973511%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.808289%, 84.979248%, 1.000977%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.918152%, 85.3302%, 1.028442%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.028015%, 85.681152%, 1.055908%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.139404%, 86.032104%, 1.0849%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.249268%, 86.383057%, 1.112366%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.359131%, 86.734009%, 1.139832%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.468994%, 87.084961%, 1.167297%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.580383%, 87.437439%, 1.194763%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.589539%, 87.467957%, 1.196289%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.598694%, 87.5%, 1.199341%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.598694%, 87.5%, 1.199341%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 266.285156 161.011719 L 312 161.011719 L 312 216.371094 L 266.285156 216.371094 Z M 266.285156 161.011719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 311 161.011719 L 356.875 161.011719 L 356.875 216.371094 L 311 216.371094 Z M 311 161.011719 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 347.792969 241.789062 L 27.902344 241.789062 C 12.761719 241.789062 0.492188 229.53125 0.492188 214.40625 L 0.492188 47.738281 C 0.492188 32.617188 12.761719 20.355469 27.902344 20.355469 L 347.792969 20.355469 C 362.933594 20.355469 375.203125 32.617188 375.203125 47.738281 L 375.203125 214.40625 C 375.203125 229.53125 362.933594 241.789062 347.792969 241.789062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#91918c",
    d: "M 57.996094 136.578125 L 57.996094 126.285156 L 40.875 126.285156 L 40.875 136.578125 Z M 73.28125 137.730469 L 69.089844 139.6875 L 69.089844 145.011719 L 73.601562 151.355469 L 83.882812 151.355469 C 87.628906 151.355469 90.664062 148.320312 90.664062 144.578125 L 90.664062 137.730469 Z M 62.542969 144.65625 L 62.542969 139.777344 L 58.4375 137.730469 L 40.875 137.730469 L 40.875 144.578125 C 40.875 148.320312 43.910156 151.355469 47.65625 151.355469 L 57.835938 151.355469 Z M 69.089844 117.941406 L 69.089844 122.824219 L 67.941406 122.824219 L 67.941406 117.605469 L 72.296875 110.789062 L 59.160156 110.789062 L 63.695312 117.808594 L 63.695312 123.140625 L 59.148438 126.027344 L 59.148438 136.800781 L 63.695312 139.070312 L 63.695312 145.019531 L 59.242188 151.355469 L 72.191406 151.355469 L 67.941406 145.382812 L 67.941406 138.953125 L 72.578125 136.789062 L 72.578125 125.136719 L 90.664062 125.136719 L 90.664062 117.566406 C 90.664062 113.824219 87.628906 110.789062 83.882812 110.789062 L 73.664062 110.789062 Z M 58.40625 125.136719 L 62.542969 122.507812 L 62.542969 118.148438 L 57.789062 110.789062 L 47.65625 110.789062 C 43.910156 110.789062 40.875 113.824219 40.875 117.566406 L 40.875 125.136719 Z M 73.730469 136.578125 L 73.730469 126.285156 L 90.664062 126.285156 L 90.664062 136.578125 L 73.730469 136.578125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f06518",
    d: "M 339.9375 190.03125 C 339.9375 201.199219 330.875 210.257812 319.691406 210.257812 C 315 210.257812 310.683594 208.65625 307.25 205.980469 C 303.820312 208.65625 299.503906 210.257812 294.8125 210.257812 C 283.628906 210.257812 274.566406 201.199219 274.566406 190.03125 C 274.566406 178.863281 283.628906 169.808594 294.8125 169.808594 C 299.503906 169.808594 303.820312 171.40625 307.25 174.082031 C 310.683594 171.40625 315 169.808594 319.691406 169.808594 C 330.875 169.808594 339.9375 178.863281 339.9375 190.03125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id4)",
    d: "M 39.65625 84.8125 L 39.65625 37.003906 L 87.46875 37.003906 L 87.46875 84.8125 Z M 39.65625 84.8125 ",
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id7)",
    d: "M 63.5625 84.8125 L 63.5625 54.691406 L 87.46875 54.691406 L 87.46875 84.8125 Z M 63.5625 84.8125 ",
    fillRule: "nonzero"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5f00",
    d: "M 299.328125 167.167969 L 323.828125 167.167969 L 323.828125 210.210938 L 299.328125 210.210938 Z M 299.328125 167.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb001b",
    d: "M 300.886719 188.691406 C 300.886719 179.960938 305.066406 172.183594 311.578125 167.171875 C 306.648438 163.371094 300.554688 161.3125 294.28125 161.316406 C 278.816406 161.316406 266.285156 173.574219 266.285156 188.691406 C 266.285156 203.808594 278.816406 216.066406 294.277344 216.066406 C 300.554688 216.074219 306.648438 214.015625 311.574219 210.210938 C 305.066406 205.199219 300.886719 197.425781 300.886719 188.691406 Z M 300.886719 188.691406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f79e1b",
    d: "M 356.875 188.691406 C 356.875 203.808594 344.339844 216.066406 328.882812 216.066406 C 322.605469 216.074219 316.507812 214.015625 311.578125 210.210938 C 318.089844 205.199219 322.273438 197.425781 322.273438 188.691406 C 322.273438 179.960938 318.089844 172.183594 311.578125 167.171875 C 316.507812 163.371094 322.605469 161.3125 328.882812 161.316406 C 344.339844 161.316406 356.875 173.574219 356.875 188.691406 Z M 356.875 188.691406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommbankCard);
export default __webpack_public_path__ + "static/media/commbank_card.a11bfa1c4c736fc99cf5013674f5b7b6.svg";
export { ForwardRef as ReactComponent };